import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DsButtonModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';

export type LicensePlateColor = 'yellow' | 'black' | 'burgundy' | 'blue';

@Component({
  selector: 'cdf-license-plate',
  imports: [DsButtonModule, DsTooltipDirectiveModule],
  template: `
    <div
      class="license-plate color-{{ color() }}"
      [class.euro]="euro()"
      [class.right-euro]="rightEuro()"
      [ds-tooltip]="i18n('vehicles.licensePlate.unknownTooltip')"
      [dsTooltipConfig]="{ disabled: !!licensePlate() }"
    >
      {{ licensePlate() || '?' }}
    </div>

    @if (canEdit()) {
      <button
        ds-button
        icon="edit"
        size="sm"
        variant="ghost"
        [ds-tooltip]="i18n('vehicles.licensePlate.editButtonTooltip')"
        [dsTooltipConfig]="{ origin: 'right' }"
        (click)="editLicensePlate.emit()"
      ></button>
    }
  `,
  styleUrl: './license-plate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicensePlateComponent {
  protected readonly i18n = useI18n();

  readonly licensePlate = input.required<string | undefined>();

  readonly euro = input(false, { transform: booleanAttribute });
  readonly rightEuro = input(false, { transform: booleanAttribute });
  readonly color = input<LicensePlateColor | undefined>(undefined);
  readonly canEdit = input(false, { transform: booleanAttribute });

  readonly editLicensePlate = output<void>();
}
